import React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";

const InputTime = (props) => {
  const {
    label,
    variant = "outlined",
    name,
    value,
    onChange,
    error,
    required = false,
    fullWidth = true,
    size,
    ...other
  } = props;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <TimePicker
        label={label}
        name={name}
        value={(value && dayjs(value)) || null}
        onChange={onChange}
        sx={{
          "& .MuiFilledInput-root::before": {
            borderBottom: `1px solid var(--${
              required ? "error" : "primary"
            }-color)`,
          },
        }}
        slotProps={{
          textField: {
            variant: variant,
            size: size || "small",
            fullWidth: fullWidth,
            ...other,
            ...(error && { error: true, helperText: error }),
            required: required,
          },
          desktopPaper: {
            style: {
              backgroundColor: "var(--white-color)",
              boxShadow: "none",
              border: "1px solid var(--primaryMD-color)",
            },
          },
          mobilePaper: {
            style: {
              backgroundColor: "var(--white-color)",
            },
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default InputTime;
